import { useEffect, useState } from "react";
import OperatorsStatus from "../OperatorsStatus";
import UserInfo from "../UserInfo";
import { useQuery } from "@tanstack/react-query";
import { financialInfo } from "@/queries/clients";
import userStore from "@/stores/user-store";
import { Menu } from "lucide-react";
import { Button } from "../ui/button";
import { useSidebar } from "../ui/sidebar";

export default function NewHeader() {
  const [date, setDate] = useState("");

  const { setOpenMobile } = useSidebar();

  const financialQuery = useQuery({
    queryFn: () => financialInfo(),
    queryKey: ["getFinancialInfo"],
  });

  useEffect(() => {
    const data: any = financialQuery.data;
    if (!financialQuery.isFetching && typeof data == "object") {
      userStore.setState((state) => ({
        ...state,
        today_points: data.data?.today_points || 0,
        profit: data.data?.profit,
        takenValues: data.data?.takenValues,
      }));
    }
  }, [financialQuery.data]);

  useEffect(() => {
    setDate(
      Intl.DateTimeFormat("fa-ir", {
        dateStyle: "medium",
        timeStyle: "short",
      }).format(new Date()),
    );
    const interval = setInterval(() => {
      setDate(
        Intl.DateTimeFormat("fa-ir", {
          dateStyle: "medium",
          timeStyle: "short",
        }).format(new Date()),
      );
    }, 60 * 1000);
    return () => {
      clearInterval(interval);
    };
  }, []);

  return (
    <header className="relative z-20 mb-3 flex min-h-12 w-full items-center justify-between gap-2 border-b border-border/70 bg-background/95 px-2 py-2 backdrop-blur">
      <div className="flex shrink-0 items-center gap-1 lg:hidden">
        <img
          src="/s-a-logo@2x.png"
          alt="esaj-logo"
          className="h-auto w-14 shrink-0"
        />
        <Button variant="ghost" size="icon" onClick={() => setOpenMobile(true)}>
          <Menu />
        </Button>
      </div>
      <div className="min-w-0 flex-1">
        <OperatorsStatus isNew />
      </div>

      <div className="flex shrink-0 items-center gap-1 sm:gap-2">
        <p className="no-font hidden whitespace-nowrap lg:block lg:text-base 2xl:text-lg">
          {date}
        </p>
        <UserInfo />
      </div>
    </header>
  );
}
